import type { RichTranslationValues } from 'next-intl';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import getLocaleFormatting, {
  getLocaleFormatString,
} from '@/utils/getLocaleFormatting';

interface RichTextProps {
  readonly messageKey: MessageKey;
  readonly tValues?: RichTranslationValues | undefined;
}

export default function RichText({ messageKey, tValues }: RichTextProps) {
  const t = useTranslations();
  return (
    <>
      {t.rich(messageKey, {
        ...getLocaleFormatString,
        ...getLocaleFormatting,
        ...tValues,
      })}
    </>
  );
}
